

































































































import { Component, Vue, Prop, Emit, Watch, Model } from 'vue-property-decorator';
import { VueCropper } from 'vue-cropper';
import { warn } from 'vue-class-component/lib/util';
import { rotateImgLeft, rotateImgRight } from '@/utils';

interface Option {
  img: string;
  outputSize: number;
  outputType: string;
  autoCrop: boolean;
  w: number;
  h: number;
}

@Component({
  components: {
    VueCropper,
  },
})
export default class UploadEdit extends Vue {
  @Model('update:dialog', { type: Boolean })
  public dialog: boolean = false;
  @Prop({ required: true })
  public src!: string;
  @Prop({ default: 'croped'})
  public downloadName!: string;
  public autoCrop = true;
  public screenHeight: number = document.documentElement.clientHeight;
  public screenWidth: number = document.documentElement.clientWidth;

  private previews = {
    url: '',
    img: null,
  };

  public mounted() {
    const that = this;
    window.onresize = () => {
      that.screenHeight = document.documentElement.clientHeight;
      that.screenWidth = document.documentElement.clientWidth;
    };
  }

  get screenHeightTooLarge() {
    return this.screenHeight > this.screenHeight;
  }

  get vcropperHeight() {
    const vcropperToolbar = 56;
    (this.$refs.vcropper as any)?.refresh();
    if (this.screenHeight < this.screenWidth) {
      return this.screenHeight - vcropperToolbar - 30;
    } else {
      return this.screenHeight - vcropperToolbar - 130;
    }
  }

  get option(): Option {
    // console.log(this.src);
    return {
      img: this.src,
      outputSize: 1,
      outputType: 'jpeg',
      autoCrop: this.autoCrop,
      w: Number.MAX_VALUE,
      h: Number.MAX_VALUE,
    };
  }

  public rotateRight() {
    rotateImgRight(this.src).then((newImg) => { this.src = newImg });
  }

  public rotateLeft() {
    rotateImgLeft(this.src).then((newImg) => { this.src = newImg });
  }

  // 实时预览函数
  public realTime(data) {
    this.previews = data;
    // console.log(data);
  }

  public imgLoad(v) {
    // console.log('imgLoad', v);
    if (v !== 'success') {
      warn('editor 加载图片失败');
    }
  }

  public close() {
    this.$emit('update:dialog', false);
  }

  public saveCrop() {
    (this.$refs.vcropper as VueCropper).getCropData((data: string /** base64 */) => {
      // console.log(data);
      this.$emit('update:img', data);
    });
    this.$emit('update:dialog', false);
  }

  public downloadCrop() {
    (this.$refs.vcropper as VueCropper).getCropData((data: string /** base64 */) => {
      // console.log(data);
      const aLink = document.createElement('a');
      aLink.download = this.downloadName;
      aLink.href = data;
      aLink.click();
      // aLink.remove();
    });
  }
}
